export interface IManualExceptionNotificationPreview {
  targetDate: string
  clientCount: number
  accountCount: number
  checkExceptionCount: number
  achExceptionCount: number
  recipients: string[]
  alreadySentToday: boolean
  nothingToSendReason: string | null
  blockedReason: string | null
  currentAttempt: number | null
  maxAttempts: number | null
}

export interface IManualExceptionNotificationSend {
  success: boolean
  blockedReason: string | null
  nothingToSendReason: string | null
  currentAttempt: number | null
  maxAttempts: number | null
}

// Reasons returned by the Background Service when the action is refused or would send nothing.
export enum EManualExceptionNotificationReason {
  JOB_NOT_STARTED = 'MANUAL_EXC_NOTIF_JOB_NOT_STARTED',
  JOB_STILL_RUNNING = 'MANUAL_EXC_NOTIF_JOB_STILL_RUNNING',
  JOB_NOT_CONFIGURED = 'MANUAL_EXC_NOTIF_JOB_NOT_CONFIGURED',
  WAITING_BOTH_TYPES = 'MANUAL_EXC_NOTIF_WAITING_BOTH_TYPES',
  NO_EXCEPTIONS = 'MANUAL_EXC_NOTIF_NO_EXCEPTIONS',
}
